import { gql } from '@apollo/client';

export const DELETE_USER_GROUP = gql`
  mutation deleteUserGroup($userGroupId: Int!) {
    deleteUserGroup(userGroupId: $userGroupId) {
      commandId
      correlationId
    }
  }
`;
